module.exports = __webpack_public_path__ + "assets/poiicon.f99951ca.svg";